// The save lifecycle of the agent record, shared by useNovaPromptState (the
// source of truth) and the Studio shell header (the display).
export const SaveState = {
	Saved: 'saved',
	Saving: 'saving',
	Unsaved: 'unsaved',
	Error: 'error',
} as const;
export type SaveState = (typeof SaveState)[keyof typeof SaveState];
